import { REAUTH_STORAGE_KEY } from '../hooks/useReAuth';

// In-memory fallback for environments where sessionStorage is unavailable (e.g. Safari incognito)
let inMemoryFlag = false;

export const setReAuthFlag = (): void => {
  inMemoryFlag = true;
  try {
    sessionStorage.setItem(REAUTH_STORAGE_KEY, 'true');
  } catch {
    // sessionStorage unavailable — in-memory fallback is already set
  }
};

export const getReAuthFlag = (): boolean => {
  if (inMemoryFlag) return true;
  try {
    return sessionStorage.getItem(REAUTH_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const clearReAuthFlag = (): void => {
  inMemoryFlag = false;
  try {
    sessionStorage.removeItem(REAUTH_STORAGE_KEY);
  } catch {
    // sessionStorage unavailable — in-memory fallback already cleared
  }
};
